module.exports = __webpack_public_path__ + "img/head-portrait.6ab6b622.jpg";